module.exports = __webpack_public_path__ + "static/media/img131.d5af4141.jpg";